import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  Col,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";

// Import images
import small from "../../../assets/images/small/img-2.jpg";
import small2 from "../../../assets/images/small/img-6.jpg";
import { FaWhatsapp } from "react-icons/fa";

const BlogList = () => {
  const [activeTab, toggleTab] = useState("1");

  // Inline styles for matching the theme
  const cardStyle = {
    background: "rgba(255, 255, 255, 0.1)",
    border: "none",
    borderRadius: "15px",
  };

  const navLinkStyle = {
    color: "#9e9e9e", // Light gray for inactive tabs
  };

  const activeNavLinkStyle = {
    color: "#ffffff", // White for active tabs
    fontWeight: "bold", // Emphasized text
    borderBottom: "2px solid #ffffff", // Highlight the active tab
  };

  const textPrimaryStyle = {
    color: "#65d6ff", // Bright accent color for links
  };

  const paginationStyle = {
    backgroundColor: "rgba(26, 3, 58, 0.5)", // Matching pagination background
    border: "1px solid rgba(255, 255, 255, 0.3)", // Subtle border
    color: "#ffffff", // Light text
  };

  const phoneNumber = "+919586363303";

  // Function to generate the WhatsApp URL with the current page URL
  const generateWhatsAppLink = () => {
    const currentPageURL = window.location.href; // Get the current page URL
    const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  return (
    <React.Fragment>
      <Col xl={12} lg={8}>
        <Card style={cardStyle}>
          <TabContent className="p-4" activeTab={activeTab}>
            <TabPane tabId="1">
              <div>
                <Row className="justify-content-center">
                  <Col xl={8}>
                    <div>
                      <Row className="align-items-center">
                        <Col xs={4}>
                          <h5 style={{ color: "#ffffff" }}>Blog List</h5>
                        </Col>
                        {/* <Col xs={8}>
                          <div className="float-end">
                            <ul className="nav nav-pills">
                              <NavItem>
                                <NavLink
                                  className="text-light"
                                  to="#"
                                  tabIndex="-1"
                                  style={navLinkStyle}
                                >
                                  View:
                                </NavLink>
                              </NavItem>
                              <NavItem>
                                <Link
                                  className="nav-link active"
                                  to="/blog-list"
                                  style={textPrimaryStyle}
                                >
                                  <i className="mdi mdi-format-list-bulleted"></i>
                                </Link>
                              </NavItem>
                              <NavItem>
                                <Link
                                  // to="/blog-grid"
                                  className="nav-link"
                                  to="/blog-grid"

                                  style={textPrimaryStyle}
                                >
                                  <i className="mdi mdi-view-grid-outline"></i>
                                </Link>
                              </NavItem>
                            </ul>
                          </div>
                        </Col> */}
                      </Row>

                      <hr style={{ borderColor: "rgba(255, 255, 255, 0.2)" }} />

                      {/* Blog Post 1 */}
                      <div>
                        <h5>
                          <Link
                            to="/blog-details"
                            className="text-light"
                            style={textPrimaryStyle}
                          >
                            Understanding Jantri: Gujarat's Land and Property Valuation System
                          </Link>
                        </h5>
                        <p className="text-muted">15 jan, 2025</p>

                        <div className="position-relative mb-3">
                          <img
                            src={small}
                            alt=""
                            className="img-thumbnail"
                            style={{
                              borderRadius: "10px",
                              border: "1px solid rgba(255, 255, 255, 0.2)",
                            }}
                          />
                        </div>

                        {/* <ul className="list-inline">
                          <li className="list-inline-item mr-3">
                            <Link to="#" className="text-muted">
                              <i className="bx bx-purchase-tag-alt align-middle text-muted me-1"></i>{" "}
                              Project
                            </Link>
                          </li>
                          <li className="list-inline-item mr-3">
                            <Link to="#" className="text-muted">
                              <i className="bx bx-comment-dots align-middle text-muted me-1"></i>{" "}
                              12 Comments
                            </Link>
                          </li>
                        </ul> */}
                        <p style={{ color: "#d3d3d3" }}>
                          The term Jantri originates from the Gujarati language and refers to the government-mandated minimum value of land and property in Gujarat, India. Officially known as the Annual Statement of Rates (ASR), the Jantri system plays a significant role in determining property transaction costs, particularly stamp duty and registration fees.....
                        </p>

                        <Link to="/blog-details" className="text-primary" style={textPrimaryStyle}>
                          Read more <i className="mdi mdi-arrow-right"></i>
                        </Link>
                      </div>

                      <hr style={{ borderColor: "rgba(255, 255, 255, 0.2)" }} />

                      {/* Pagination */}
                      <div className="text-center">
                        <ul className="pagination justify-content-center pagination-rounded">
                          <li className="page-item disabled">
                            <Link
                              to="#"
                              className="page-link"
                              style={paginationStyle}
                            >
                              <i className="mdi mdi-chevron-left"></i>
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link
                              to="#"
                              className="page-link"
                              style={paginationStyle}
                            >
                              1
                            </Link>
                          </li>
                          <li className="page-item active">
                            <Link
                              to="#"
                              className="page-link"
                              style={paginationStyle}
                            >
                              2
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link
                              to="#"
                              className="page-link"
                              style={paginationStyle}
                            >
                              3
                            </Link>
                          </li>
                          <li className="page-item">
                            <Link
                              to="#"
                              className="page-link"
                              style={paginationStyle}
                            >
                              <i className="mdi mdi-chevron-right"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </TabPane>
          </TabContent>
          <div
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            {/* Icons Container */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "12px",
                gap: "10px", // Reduced gap for a more compact design
              }}
            >
              {/* WhatsApp Icon */}
              <a
                href={generateWhatsAppLink()}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: "white",
                  fontSize: "1.2rem", // Reduced font size
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "40px", // Reduced icon size
                  height: "40px",
                  background: "linear-gradient(135deg, #1FAF51, #25D366)", // Slightly adjusted green gradient
                  borderRadius: "50%",
                  boxShadow: "0px 3px 10px rgba(31, 175, 81, 0.6)",
                  transition: "all 0.3s ease",
                }}
                title="Chat on WhatsApp"
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.1)";
                  e.target.style.boxShadow = "0px 5px 15px rgba(31, 175, 81, 0.8)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0px 3px 10px rgba(31, 175, 81, 0.6)";
                }}
              >
                <FaWhatsapp />
              </a>

              {/* Call Icon */}
              <a
                href="tel:+919586363303"
                style={{
                  color: "white",
                  fontSize: "1.2rem", // Reduced font size
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "40px", // Reduced icon size
                  height: "40px",
                  background: "linear-gradient(135deg, #1E90FF, #34B7F1)", // Slightly adjusted blue gradient
                  borderRadius: "50%",
                  boxShadow: "0px 3px 10px rgba(30, 144, 255, 0.6)",
                  transition: "all 0.3s ease",
                }}
                title="Call Us"
                onMouseEnter={(e) => {
                  e.target.style.transform = "scale(1.1)";
                  e.target.style.boxShadow = "0px 5px 15px rgba(30, 144, 255, 0.8)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "scale(1)";
                  e.target.style.boxShadow = "0px 3px 10px rgba(30, 144, 255, 0.6)";
                }}
              >
                <i className="fas fa-phone" />
              </a>
            </div>

            {/* Query Button */}
            <Link
              to="/dashboard"
              title="Any Questions or Queries?"
              style={{
                background: "linear-gradient(135deg, #6a11cb, #2575fc)", // Gradient effect for the button
                border: "none",
                borderRadius: "9999px",
                padding: "10px 20px", // Adjusted padding
                fontSize: "14px", // Reduced font size
                color: "white",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "scale(1.1)";
                e.target.style.boxShadow = "0px 6px 18px rgba(0, 0, 0, 0.4)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "scale(1)";
                e.target.style.boxShadow = "0px 4px 12px rgba(0, 0, 0, 0.3)";
              }}
            >
              Ask Ai &nbsp; <i className="fas fa-question" style={{ margin: 0 }}></i>
            </Link>
          </div>

        </Card>
      </Col>
    </React.Fragment>
  );
};

export default BlogList;
